// extracted by mini-css-extract-plugin
export default {"h1":"API_h1__P1lsN","subtitle":"API_subtitle__N29I9"};